






































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { $eventBus } from '@/eventBus';

@Component
export default class BaseColumn extends Vue {
  collapsed: boolean = false;
  reSized: boolean = false;
  reSizedWidth: number = 0;
  regularWidth: number = 24;
  collapsedWidth: number = 44;
  handleStyle: any = {
    width: this.regularWidth + 'px',
  };


  @Prop({ default: false })
  handleLeft!: boolean;

  @Prop({ default: false })
  handleRight!: boolean;

  @Prop({ default: null })
  preferedWidth!: number | null;

  @Prop({ default: 0 })
  minWidth!: number;

  @Prop({ default: 10000 })
  maxWidth!: number;

  @Prop({ default: 1 })
  flexGrow!: number;

  @Prop({ default: 1 })
  flexShrink!: number;

  @Prop({ default: '' })
  text!: string;

  @Prop({ default: null })
  iconName!: string | null;



  get style() {
    // TODO REWRITE PRETTIER
    if (this.collapsed) {
      this.handleStyle.width = this.collapsedWidth + 'px';
      return {
        flexBasis: 0,
        minWidth: this.handleStyle.width,
        maxWidth: this.handleStyle.width,
        flexGrow: 0,
        flexShrink: 0,
      };
    }
    // this.handleStyle.width = this.regularWidth + "px";
    this.handleStyle.width = this.collapsedWidth + 'px';
    if (this.reSized) {
      return {
        flexBasis: this.reSizedWidth + 'px',
        minWidth: this.minWidth + 'px',
        maxWidth: this.maxWidth + 'px',
        flexGrow: 0,
        flexShrink: 0,
      };
    }
    return {
      flexBasis: this.preferedWidth ? this.preferedWidth + 'px' : 'auto',
      minWidth: this.minWidth + 'px',
      maxWidth: this.maxWidth + 'px',
      flexGrow: this.flexGrow,
      flexShrink: this.flexShrink,
    };
  }


  toggleCollapse() {
    this.collapsed = !this.collapsed;
  }
  collapseColumn() {
    if (this.handleRight || this.handleLeft) {
      this.collapsed = true;
    }
  }
  openColumn() {
    if (this.handleRight || this.handleLeft) {
      this.collapsed = false;
    }
  }
  resizeLeft(event: any) {
    this.resizeColumn(event, 'left');
  }
  resizeRight(event: any) {
    this.resizeColumn(event, 'right');
  }
  resizeColumn(event: any, side: 'left' | 'right') {
    const mousePosition = event.clientX;
    if (mousePosition === 0) { return; }

    const column = this.$refs.column as Element;
    const columnBounds = column.getBoundingClientRect() as DOMRect;
    if (side === 'right') {
      const baseLine = columnBounds.x;
      this.reSizedWidth = mousePosition - baseLine;
    } else if (side === 'left') {
      const baseLine = columnBounds.x + columnBounds.width;
      this.reSizedWidth = baseLine - mousePosition;
    }

    if (this.reSizedWidth < this.collapsedWidth) {
      this.collapsed = true;
    } else {
      this.collapsed = false;
    }
    this.reSized = true;
  }

  mounted() {
    $eventBus.$on('closeAllColumns', this.collapseColumn);
    $eventBus.$on('openAllColumns', this.openColumn);
  }
  beforeDestroy() {
    $eventBus.$off('closeAllColumns', this.collapseColumn);
    $eventBus.$off('openAllColumns', this.openColumn);
  }
}
